import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'

export function createTrackConfig() {
  const id = window.location.href.split('/')[window.location.href.split('/').length - 1]

  return {
    poizon_venue_component_content_click(platform, dataset) {
      const { blocktype } = dataset
      console.log('poizon_venue_component_content_click', {
        current_page: 82,
        block_type: blocktype,
        venue_id: id,
        venue_title: document.title,
        poizon_component_type: 'poizon-brand-wall',
        poizon_component_name: '商品墙',
        component_content_url: dataset.url,
        poizon_channel_id,
      })
      return {
        current_page: 82,
        block_type: blocktype,
        venue_id: id,
        venue_title: document.title,
        component_content_url: dataset.url,
        poizon_component_type: 'poizon-brand-wall',
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },
    poizon_venue_component_content_exposure(platform, dataset) {
      const { blocktype } = dataset
      console.log('poizon_venue_component_content_exposure', {
        current_page: 82,
        block_type: blocktype,
        venue_id: 1,
        venue_title: document.title,
        poizon_component_type: 'poizon-brand-wall',
        poizon_component_name: '商品墙',
        poizon_channel_id,
      })
      return {
        current_page: 82,
        block_type: blocktype,
        venue_id: 1,
        venue_title: document.title,
        poizon_component_type: 'poizon-brand-wall',
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },
  }
}
